import React, { useState } from "react";
import { Modal } from "antd";
import Button from "./button";
import "react-image-crop/dist/ReactCrop.css";
import { colors } from "../../share/constants/enums";
import ImageCropper from "./ImageCropper";
import { RotateLeftOutlined, RotateRightOutlined } from "@ant-design/icons";

const CustomOkButton = ({ onClick }) => (
  <Button
    title="Yes"
    onClick={onClick}
    className="bg-lightBlue !text-black w-full focus:bg-primaryBlue !focus:text-white sm:w-19 h-5.4 !hover:shadow-none"
  />
);

const CustomCancelButton = ({ onClick }) => (
  <Button
    title="No"
    onClick={onClick}
    className="bg-lightBlue hover:bg-lightBlue focus:bg-primaryBlue !focus:text-white w-full sm:w-19 h-5.4 !text-black"
  />
);

const ImageUpload = ({
  onCancel,
  onOk,
  text,
  title,
  statImage,
  handleUploadTos3,
}) => {
  const [croppedImage, setCroppedImage] = useState();
  const [rotation, setRotation] = useState(0);

  const handleOnImageCrop = (file) => {
    setCroppedImage(file);
  };

  const rotateImage = (angle) => {
    setRotation((prevRotation) => prevRotation + angle);
  };

  return (
    <div>
      <Modal
        open={true}
        footer={null}
        maskClosable={true}
        closeIcon={null}
        className="space-y-20"
        onCancel={onCancel}
        width="479px"
      >
        {/* <div className=" flex justify-center w-full mt-1"> */}
        <div className="flex justify-center ml-1.5 mt-1.5 sm:h-[300px] sm:w-[300px] md:h-[400px] md:w-[400px]">
          <ImageCropper
            imageToCrop={statImage}
            onImageCropped={handleOnImageCrop}
            rotation={rotation}
          />
        </div>
        {/* </div> */}
        <div className="flex justify-center my-2">
          <RotateLeftOutlined
            className="text-xl mr-2"
            onClick={() => rotateImage(-90)}
          />
          <RotateRightOutlined
            className="text-xl"
            onClick={() => rotateImage(90)}
          />
        </div>

        <div className="flex justify-center  ">
          <Button
            color={colors.primaryBlue}
            title={"Save"}
            className="flex items-center w-20 mt-1"
            onClick={() => handleUploadTos3(croppedImage, rotation)}
          />
        </div>
      </Modal>
    </div>
  );
};

export default ImageUpload;
